export default __webpack_public_path__ + "static/media/video1.ccefd688.mp4";